<script lang="ts">
    import '../../css/app.pcss';
    import { createQuery } from '@tanstack/svelte-query';
    import { CartApi } from '$lib/api/cartApi.js';
    import type { ApiSchemas } from '$lib/api/shopwareApi.js';
    import type { LayoutServerData } from '../../routes/(app)/[language=language]/$types';
    import Cookies from 'js-cookie';
    import MainNavbar from '$lib/components/navigation/MainNavbar.svelte';
    import Footer from '$lib/components/navigation/Footer.svelte';
    import { ContextApi } from '$lib/api/contextApi.js';
    import { useShopContext } from '$lib/context.js';

    const shopContext = useShopContext();

    export let data: LayoutServerData;

    let dropdownActive: boolean;

    $: cartQuery = createQuery({
        queryKey: ['cart'],
        queryFn: () => CartApi.getCart(data.shopContext),
        staleTime: 30 * 1000,
        gcTime: 120 * 1000
    });

    let cart: ApiSchemas['Cart'];
    $: cart = $cartQuery.data;

    const paymentMethodsQuery = createQuery({
        queryKey: ['payments'],
        queryFn: () => ContextApi.getPaymentMethods(shopContext),
        staleTime: 20 * 60 * 1000,
        gcTime: 40 * 60 * 1000
    });

    $: paymentMethods = ($paymentMethodsQuery.data?.elements ?? []) as ApiSchemas['PaymentMethod'][];

    async function logout(event: MouseEvent) {
        event.preventDefault();

        Cookies.remove('sw-context-token', {
            expires: 365, // days
            path: '/',
            sameSite: 'lax',
            secure: false
        });

        window.location.reload();
    }
</script>

<main class="min-h-screen">
    <MainNavbar
        bind:dropdownActive
        cartLineItemAmount={cart?.lineItems?.filter((li) => li.type === 'product').length ?? 0}
    />
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        on:click={() => {
            if (dropdownActive) dropdownActive = false;
        }}
    >
        <slot />
    </div>
    <Footer {paymentMethods} />
</main>
